import { useEffect, useState } from "react";
import { addNewRow, handleFormItemChange } from "../../../../common/services/add-new-row";
import GlobalDbnTaxonomySubDomainAttributeBasicInfoComponent from "./global-dbn-taxonomy-sub-domain-attribute-basic-info.component";
import { useParams } from "react-router-dom";
import { deepCopy } from "../../../../common/services/common.service";

export const GlobalDbnTaxonomySubDomainAttributeComponent = ({attributes, subDomains, libraryData, handleSave, back}: any) => {
    console.log('subDomains', subDomains)
    console.log('attributes', attributes)
    const params: any = useParams()
    
    const [data, setData] = useState<{ Id: Number, Name: string; SubDomainId: number; AttributeValueSource: any }[]>([]);
    const newRow = {
        Id: 0, Name: '', SubDomainId: 0, AttributeValueSource: {
            SourceAttributeName: '', ControlType: '', SourceType: '', SourceTypeName: '', IsAppliedForVariant: false
        }
    };

    // const removeItem = (index: number) => () => {
    //     console.log('data', data)
    //     const localData = deepCopy(data)
    //     console.log('removing item at index', index)
    //     if (index < 0 || index >= localData.length) {
    //         return localData; // Return original array if index is out of bounds
    //     }
    //     localData.splice(index, 1); // Remove 1 element at the given index
    //     console.log('after data', localData)
    //     // return data;
    //     setData(localData);
    // }

    const isRowEmpty = (row: {
        Id: Number, Name: string, SubDomainId: number, AttributeValueSource: {
            SourceAttributeName: string, ControlType: string, SourceType: string, SourceTypeName: string, IsAppliedForVariant: boolean
        }
    }) =>
        row?.Name === '' && row?.SubDomainId === 0 && row?.AttributeValueSource?.SourceAttributeName === '' && 
        row?.AttributeValueSource?.ControlType === '' && row?.AttributeValueSource?.SourceType === '' && 
        row?.AttributeValueSource?.SourceTypeName === '' && row?.AttributeValueSource?.IsAppliedForVariant === false;

    // Ensure at least one row exists when the component mounts
    useEffect(() => {
        setData(attributes.map((o) => {return {...o, Id: o.DBNSubDomainAttributeId}}));
        setData((prevData) => addNewRow(prevData, newRow, isRowEmpty));
    }, [attributes]);

    const handleFormSubmit = (event: any) => {
        event.preventDefault();
        data.splice(
            data.length - 1,
            1
          )

        handleSave(data)
    }
    

    return (
        <div>
            <div className='p-4 bg-white'>
                <h3 className="text-2xl font-bold">{`${params?.id > 0? 'Edit attribute(s)': 'Add new attribute(s)'}`}</h3>
            </div>
            <table className="p-5 min-w-full divide-y divide-gray-200">
                <thead>
                    <tr>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sub Domain</th>
                        {/* <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source Name</th> */}
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source Attribute Name</th>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Control Type</th>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source Type</th>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source Type Name</th>
                        <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Applied For Variant</th>
                        {/* <th className="px-2 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th> */}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item: any, index) => (
                        <>
                        <tr>
                            <GlobalDbnTaxonomySubDomainAttributeBasicInfoComponent
                                subDomains={subDomains}
                                item={item}
                                libraryData={libraryData}
                                handleFormItemChange={handleFormItemChange}
                                selectedDomain={''}
                                parentDomain={''}
                                setData={setData}
                                index={index}
                                newRow={newRow}
                                isRowEmpty={isRowEmpty}
                                // removeItem={removeItem}
                                // isLastRow={data.length - index === 1}
                            />
                        </tr>
                        </>
                    ))}
                </tbody>
            </table>
            <div className='flex w-full justify-end items-end'>
                <button
                onClick={back}
                type='button'
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                Back
                </button>
                <button
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                onClick={handleFormSubmit}

                type="submit"
                >
                Save
                </button>
            </div>            
        </div>
    );
};

